import axios from "axios";
import config from "./config";

const axiosInstance = axios.create({
  baseURL: config.BACKEND_CORE_URL,
  // headers: { "Access-Control-Allow-Origin": "*" },
});

export default axiosInstance;
